import type {
  HubAlgorithmDefinition,
  HubBlobDependency,
  HubBlobResourceDefinition,
} from '@robovision/hub'
import {
  JobBaseDependency,
  type JobBaseDependencyParams,
} from './JobBaseDependency'


export interface JobBlobDependencyParams extends JobBaseDependencyParams {
  blobDefinition: HubBlobResourceDefinition
}

export class JobBlobDependency extends JobBaseDependency {
  public blobDefinition: HubBlobResourceDefinition

  protected constructor (params: JobBlobDependencyParams) {
    super(params)
    this.blobDefinition = params.blobDefinition
  }

  public static fromDefinition (
    blobDependency: HubBlobDependency,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const blobDefinition = algorithmDefinition.blobDefinitions?.find(
      (def) => def.id === blobDependency.blobDefinition,
    )

    if (!blobDefinition) {
      throw new Error(
        `Invalid schema. Blob definition ${blobDependency.blobDefinition} not found`,
      )
    }

    return new JobBlobDependency({
      blobDefinition,
      definitionId: blobDependency.blobDefinition,
      dependencyId: blobDependency.id,
      description: blobDependency.description,
      name: blobDependency.name,
      optional: blobDependency.optional,
    })
  }
}
